/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {  Observable } from 'rxjs';
import { ResiduService } from '../../../controllers/Residu';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGGetFormService } from '../../yasag-get.service';


@Injectable()
export class ResiduExportResidusFormService extends YASAGGetFormService<string> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    search: new FormControl({value: undefined, disabled: false}, []),
    limit: new FormControl({value: undefined, disabled: false}, []),
    offset: new FormControl({value: undefined, disabled: false}, []),
    fields: new FormControl({value: undefined, disabled: false}, []),
    expand: new FormControl({value: undefined, disabled: false}, []),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: ResiduService,
  ) {
    super('ResiduExportResidus', apiConfigService, ngZone);
    this.init();
  }

  submit(value: typeof this.form.value | false = false, cache = true, only_cache = false): Observable<string> {
    const result = val => this.service.exportResidus(val);
    return this._submit('string', result, value, cache, only_cache );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<string> {
    if (submit) {
      this.submit(value);
    }
    return this._listen('string', value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    super.reset(value, false); 
  }
  patch(value: typeof this.form.value): void {
    this.form.patchValue(value);
  }
}
